export function googleFaviconUrl(domain: string | null, { size = 64 } = {}): string {
  if (!domain) return ''

  const cleaned = String(domain).trim()
  if (!cleaned) return ''

  const url = cleaned.startsWith('http://') || cleaned.startsWith('https://') ? cleaned : `https://${cleaned}`
  const params = new URLSearchParams({
    client: 'SOCIAL',
    type: 'FAVICON',
    fallback_opts: 'TYPE,SIZE,URL',
    url,
    size: String(size),
  })

  return `https://t1.gstatic.com/faviconV2?${params.toString()}`
}

// A missing favicon comes back as a 404 16px globe at any requested size.
export const FAVICON_PROBE_SIZE = 64
const MISSING_FAVICON_PX = 16
const PROBE_TIMEOUT_MS = 1500

export function hasFavicon(domain: string): Promise<boolean> {
  return new Promise((resolve) => {
    const img = new Image()
    const timer = setTimeout(() => resolve(false), PROBE_TIMEOUT_MS)
    img.onload = () => {
      clearTimeout(timer)
      resolve(img.naturalWidth > MISSING_FAVICON_PX)
    }
    img.onerror = () => {
      clearTimeout(timer)
      resolve(false)
    }
    img.src = googleFaviconUrl(domain, { size: FAVICON_PROBE_SIZE })
  })
}
